import {
	ChangeDetectionStrategy,
	Component,
	Input,
	QueryList
} from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';
import { GoStepComponent } from './go-step/go-step.component';

@Component({
	selector: 'go-stepper',
	templateUrl: './go-stepper.component.html',
	styleUrls: ['./go-stepper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{
		provide: CdkStepper, useExisting: GoStepperComponent
	}],
	standalone: false
})
export class GoStepperComponent extends CdkStepper  {
	@Input()
	public goStepperClass = '';
	public hideWrapper: boolean;
	public readonly steps: QueryList<GoStepComponent>;

	public get hideStepsIndicator (): boolean {
		return (this.selected as GoStepComponent)?.hideIndicator;
	}

	public isSelected (stepIndex: number) {
		return this.selectedIndex >= stepIndex;
	}
}
